const AboutUs = () => {
    return (
        <div className="max-w-4xl mx-auto py-12 md:py-20 px-6">
            <h1 className="text-4xl md:text-6xl font-bold text-center mb-8">We are <span className="text-blue-600">Seeker</span></h1>
            <p className="text-xl md:text-2xl text-zinc-500 text-center mb-20 max-w-2xl mx-auto">
                Building the future of e-commerce with a focus on quality, speed, and exceptional customer experience.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-24">
                <div>
                    <img
                        src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                        alt="Our Team"
                        className="rounded-3xl shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-500"
                    />
                </div>
                <div>
                    <h2 className="text-3xl font-bold mb-6">Our Story</h2>
                    <p className="text-zinc-600 leading-relaxed mb-6">
                        Founded in 2024, Seeker started with a simple mission: to make high-quality products accessible to everyone in Ghana. We noticed a gap in the market for a reliable, premium e-commerce platform that puts the customer first.
                    </p>
                    <p className="text-zinc-600 leading-relaxed">
                        Today, we serve thousands of happy customers, delivering everything from fashion to electronics right to your doorstep. We are driven by innovation and a relentless commitment to quality.
                    </p>
                </div>
            </div>

            <div className="mb-24">
                <h2 className="text-3xl font-bold mb-12 text-center">Our Values</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="p-8 bg-zinc-50 rounded-3xl text-center">
                        <h3 className="text-xl font-bold mb-4">Quality First</h3>
                        <p className="text-zinc-500">We carefully curate every product to ensure it meets our high standards.</p>
                    </div>
                    <div className="p-8 bg-zinc-50 rounded-3xl text-center">
                        <h3 className="text-xl font-bold mb-4">Customer Obsessed</h3>
                        <p className="text-zinc-500">We go above and beyond to ensure you have a seamless shopping experience.</p>
                    </div>
                    <div className="p-8 bg-zinc-50 rounded-3xl text-center">
                        <h3 className="text-xl font-bold mb-4">Fast Delivery</h3>
                        <p className="text-zinc-500">We understand you want your items fast, so we optimized our logistics.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
